<template>
    <div>
        <div id="panel-4" class="panel">
            <div class="panel-hdr ">
                <h2>
                    {{ __t('LIST') }} <span class="fw-300"><i>{{__t('ARTICLES')}}</i></span>
                </h2>

                <div class="panel-toolbar">
                    <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                        <i class="fal fa-plus"></i>
                    </button>

                    <button class="btn btn-panel waves-effect waves-themed"
                            data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <div class="panel-content">
                    <div class="filter_block mb-3">
                       <filter_articles></filter_articles>
                    </div>

                    <b-skeleton-table v-if="is_load" :rows=this.cur_records :columns="2" :hide-header=true :table-props="{ bordered: false, striped: true }"/>

                    <div class="inbox_vue_list" v-if="!is_load">

                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list key="up" :total="pagination.total" :limit="pagination.limit" :current="pagination.pagesCurrent" @page-change="handlePageChange"></pagination_list>
                        </div>

                        <b-table
                            v-if="rows.length > 0"
                            :tbody-tr-class="rowClass"
                            striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

                            <!-- header fields -->
                            <template v-slot:head(id)="data">
                                <div class="status_info" style="max-width: 50px">
                                    {{ __t('STATUS') }}
                                </div>
                            </template>

                            <template v-slot:head(uniq_id)="data">
                                <grid_list
                                    :list_ordering="'uniq_id'"
                                    :field_name="__t('UNIQ_ID')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(displayName)="data">
                                <grid_list
                                    :list_ordering="'displayName'"
                                    :field_name="__t('TITLE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(short_code)="data">
                                <grid_list
                                    :list_ordering="'short_code'"
                                    :field_name="__t('SHORT_CODE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(created_at)="data">
                                {{__t('DATE')}}
                            </template>


                            <!-- body draw -->
                            <template  v-slot:cell(id)="data">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        :disabled="true"
                                        :name="'cid[]'"
                                        v-model="data.item.state"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="data.item.id + '_cust_id'" />
                                    <label class="custom-control-label cursor-pointer bolder" :for="data.item.id + '_cust_id'"></label>
                                </div>
                            </template>


                            <template v-slot:cell(title)="data">
                                <div class="">
                                    <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                        <div  class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer" v-on:click="open_item(data.item)">
                                            <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                            <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                        </div>
                                        <span v-html=nice_search(data.item.title)></span>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:cell(group_id)="data">
                                <div class="prod_name  fs-xl color-success-600">
                                    <span v-html="nice_search((data.item.group || {}).title)"></span>
                                </div>
                            </template>

                            <template v-slot:cell(displayName)="data">
                                <div class="prod_name  fs-xl color-success-600">
                                    <span v-html=nice_search(data.item.displayName)></span>
                                </div>
                            </template>

                        </b-table>


                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list key="down" :total="pagination.total" :limit="pagination.limit" :current="pagination.pagesCurrent" @page-change="handlePageChange"></pagination_list>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <article_modal></article_modal>

    </div>
</template>

<script>

import {mapGetters} from "vuex";



import Grid_list from "../../../sys/list/grid_list.vue";
import Pagination_list from "../../../sys/list/pagination_list.vue";


import article_modal from "../modal/item/article_modal.vue";
import filter_articles from "./filter_articles.vue";



export default {
    name: "pwa_news_list",
    components : {
        article_modal,
        Grid_list,
        Pagination_list,
        filter_articles,
    },
    data() {
        return {
            rows: [],
            is_load: true,
            is_check_all: false,
            cur_records: 35,
            component_type: "news",
            grid_trigger: "news_inbox_change_state",

            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },

            filter: {
                search: "",
                provider_id: "",
                group_id: ""
            },

            fields: [
                { key: 'id', label: '', class: 'text-center' },
                { key: 'title', label: '', class: '' },
                { key: 'group_id', label: 'group_id', class: '' },
                { key: 'created_at', label: 'e.created_at', class: '' },
            ]
        }
    },

    mounted() {
        this.load_items();
    },

    created() {
        EventBus.$on("search_news_called",this.search_work);
        EventBus.$on("clean_news_filter",this.clean_inbox_filter);
        EventBus.$on("org_filter_changed",this.filter_select);


        EventBus.$on("news_reload_items",this.load_items);
        EventBus.$on(this.grid_trigger,this.change_state)
        EventBus.$on("reload_news",this.load_items);

    },

    methods : {

        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },

        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },

        search_work(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },

        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },

        clean_inbox_filter() {

            this.filter = {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            };

            this.list = {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            };

            this.load_items();
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/pwa/news/articles', {
                filter  : this.filter,
                list    : this.list
            }).then(({ data }) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.rows = data.data;

                        if (data.message?.pagination) {
                            this.pagination = data.message.pagination;
                        }
                    }
                })
                .catch(({ response }) => {
                    this.is_load = false;
                    this.rows = [];
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    });
                });
        },


        rowClass(item) {
            if (!item) return;
            return item.class;
        },

        open_item (item) {
            EventBus.$emit("news_edit",parseInt(item.id));
        },

        create() {
            EventBus.$emit("news_edit",0);
        },

        nice_search(str) {
            if (!this.filter.hasOwnProperty('search')) {
                return str;
            }
            return str.replace(new RegExp(this.filter.search, "i"), match => {
                return '<span class="text-danger">' + match + '</span>';
            });

        },
    },
    computed: {

        ...mapGetters({
            'user' : "user/getUser",
        }),
    }
}
</script>

<style scoped>
.table thead th:first-child {
    max-width: 20px;
}
</style>
